import SeminarAbout from './SeminarAbout.component';

export default SeminarAbout;
